// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/user-round-cog.js';

import { paths } from '../generated/user-round-cog';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('user-round-cog', Original, paths);
